export { default as LoyaltyBasicCardWidget } from './loyalty-basic-card-widget';
